import { Alert, Text } from '@vtex/admin-ui'
import { FormattedMessage } from 'react-intl'
import { useNumbers } from 'ui/components/utils/useNumbers'
import {
  MoreForLessBenefitVariant,
  MoreForLessEffect,
} from '../../../../../typings'
import { messages } from '../messages'

export function MoreForLessRecap(props: { moreForLess: MoreForLessEffect }) {
  const {
    moreForLess: { trigger, benefit },
  } = props

  const { formatPercentual, formatCurrency } = useNumbers()

  if (!trigger || !benefit) return null

  const {
    discount: { type, value = 0 },
  } = benefit

  const isPercentual = type === MoreForLessBenefitVariant.PERCENTUAL

  const mountDiscountValue = () => {
    if (isPercentual) {
      return formatPercentual(value)
    }

    return formatCurrency(value)
  }

  return (
    <Alert variant="info">
      <FormattedMessage
        {...messages.moreForLess.recap}
        values={{
          minQuantity: trigger.minQuantity,
          equals: benefit.apply.equals,
          quantity: benefit.quantity,
          isPercent: isPercentual,
          discount: mountDiscountValue(),
          b: (content) => <Text variant="action1">{content}</Text>,
        }}
      />
    </Alert>
  )
}
